<template>
  <v-card color="transparent" flat class="mt-2 text-custom-color">
    <p class="title font-weight-bold text-center">
      Comparte tus experiencias con la comunidad
    </p>
    <v-row class="ml-1">
      <v-col cols="4">
        <div class="flex d-flex justify-center">
          <SvgIcon
            icon="cp-outlined-diver-1"
            fill="#c0e2e6"
            :height="imageHeight"
          />
        </div>
        <p class="headline font-weight-bold text-center mb-0">
          {{ data.practitionerTotal || "0" }}
        </p>
        <p class="body-1 text-center">usuarios</p>
      </v-col>
      <v-col cols="4">
        <div class="flex d-flex justify-center">
          <SvgIcon
            icon="cp-outlined-diver-2"
            fill="#c0e2e6"
            :height="imageHeight"
          />
        </div>
        <p class="headline font-weight-bold text-center mb-0">
          {{ data.eventTotal || "0" }}
        </p>
        <p class="body-1 text-center">buceos</p>
      </v-col>
      <v-col cols="4">
        <div class="flex d-flex justify-center">
          <SvgIcon
            icon="cp-outlined-fish-1"
            fill="#c0e2e6"
            :height="imageHeight"
          />
        </div>
        <p class="headline font-weight-bold text-center mb-0">
          {{ data.organismTotal || "0" }}
        </p>
        <p class="body-1 text-center">especies</p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import SvgIcon from "../SvgIcon";
export default {
  components: { SvgIcon },
  data: () => ({
    data: {}
  }),
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "70px";
        default:
          return "140px";
      }
    }
  },
  async mounted() {
    try {
      let { data } = await this.$http.get("home/get-indicators");
      this.data = data;
    } catch (err) {
      this.data = {};
    }
  }
};
</script>

<style>
.text-custom-color p {
  color: #c0e2e6;
}
</style>
